/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArenaScoringEventTargetRange } from './ArenaScoringEventTargetRange';
import {
    ArenaScoringEventTargetRangeFromJSON,
    ArenaScoringEventTargetRangeFromJSONTyped,
    ArenaScoringEventTargetRangeToJSON,
    ArenaScoringEventTargetRangeToJSONTyped,
} from './ArenaScoringEventTargetRange';

/**
 * Arena scoring event - ties an EventType to scoring with optional conditions
 * @export
 * @interface ArenaScoringEvent
 */
export interface ArenaScoringEvent {
    /**
     * EventType ID from the game's available events
     * @type {string}
     * @memberof ArenaScoringEvent
     */
    eventTypeId?: string;
    /**
     * EventType name for display purposes
     * @type {string}
     * @memberof ArenaScoringEvent
     */
    eventTypeName?: string;
    /**
     * Points awarded when this event fires (for SCORE_ACCUMULATION)
     * @type {number}
     * @memberof ArenaScoringEvent
     */
    points?: number;
    /**
     * Default target count (for METRIC_THRESHOLD)
     * @type {number}
     * @memberof ArenaScoringEvent
     */
    defaultTarget?: number;
    /**
     * 
     * @type {ArenaScoringEventTargetRange}
     * @memberof ArenaScoringEvent
     */
    targetRange?: ArenaScoringEventTargetRange;
    /**
     * JSON Logic conditions for filtering
     * @type {object}
     * @memberof ArenaScoringEvent
     */
    jsonValidator?: object;
}

/**
 * Check if a given object implements the ArenaScoringEvent interface.
 */
export function instanceOfArenaScoringEvent(value: object): value is ArenaScoringEvent {
    return true;
}

export function ArenaScoringEventFromJSON(json: any): ArenaScoringEvent {
    return ArenaScoringEventFromJSONTyped(json, false);
}

export function ArenaScoringEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArenaScoringEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'eventTypeId': json['eventTypeId'] == null ? undefined : json['eventTypeId'],
        'eventTypeName': json['eventTypeName'] == null ? undefined : json['eventTypeName'],
        'points': json['points'] == null ? undefined : json['points'],
        'defaultTarget': json['defaultTarget'] == null ? undefined : json['defaultTarget'],
        'targetRange': json['targetRange'] == null ? undefined : ArenaScoringEventTargetRangeFromJSON(json['targetRange']),
        'jsonValidator': json['jsonValidator'] == null ? undefined : json['jsonValidator'],
    };
}

export function ArenaScoringEventToJSON(json: any): ArenaScoringEvent {
    return ArenaScoringEventToJSONTyped(json, false);
}

export function ArenaScoringEventToJSONTyped(value?: ArenaScoringEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventTypeId': value['eventTypeId'],
        'eventTypeName': value['eventTypeName'],
        'points': value['points'],
        'defaultTarget': value['defaultTarget'],
        'targetRange': ArenaScoringEventTargetRangeToJSON(value['targetRange']),
        'jsonValidator': value['jsonValidator'],
    };
}

